import React, {ReactElement} from 'react';
import {HeaderDrawerProp, splitDrawerLinksIntoColumns} from './headerUtils';
import useOpenAndClosedTransition from '../../../../useOpenAndClosedTransition';
import DynamicLink from '../../../DynamicLink/DynamicLink';

import './HeaderDrawer.scss';

type Props = {
  links: HeaderDrawerProp[];
  isOpen: boolean;
};

function HeaderDrawer({links, isOpen}: Props): ReactElement {
  const columnsData: HeaderDrawerProp[][] = splitDrawerLinksIntoColumns(links);
  const drawerContainerRef = useOpenAndClosedTransition(isOpen);

  return (
    <div className={`headerDrawer ${isOpen ? 'headerDrawer--open' : ''}`} ref={drawerContainerRef}>
      <div className="headerDrawer__linksContainers">
        {columnsData.map((entriesColumn: HeaderDrawerProp[], i: number) => {
          return (
            <div className="headerDrawer__linksContainers__column" key={i.toString()}>
              {entriesColumn.map((entry: HeaderDrawerProp) => {
                return (
                  <DynamicLink
                    href={entry.href}
                    className={`col-xs-12 middle-xs headerDrawer__link unstyledLink ${
                      entry.isPrimary ? 'headerDrawer__link--primary' : ''
                    }`}
                    key={entry.label}
                  >
                    {entry.label}
                  </DynamicLink>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HeaderDrawer;
